import { render, staticRenderFns } from "./BasicBadge.vue?vue&type=template&id=6040a771&scoped=true"
import script from "./BasicBadge.vue?vue&type=script&setup=true&lang=ts"
export * from "./BasicBadge.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BasicBadge.vue?vue&type=style&index=0&id=6040a771&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6040a771",
  null
  
)

export default component.exports